import { FormControl, FormLabel, Grid, LinearProgress } from "@material-ui/core";
import { FileAttachmentList } from "components/file-attachment-list";
import { Spacer } from "components/utility-components";
import { FileModel } from "model/autogen/FileModel";
import { downloadLinkResolver } from "pages/brief-item-page";
import React from "react";
import Dropzone from "react-dropzone";
import { isArrayNullOrEmpty } from "utils/array";
import DEFAULT_DROPZONE_STYLE from "../dropzone-style";

type UploadSectionProps = {
    files: FileModel[];
    assignFiles: FileModel[];
    isUploadingFiles: boolean;
    onFileDrop: (acceptedFiles: File[], rejectedFiles: File[]) => void;
}

export const UploadSection: React.FC<UploadSectionProps> = ({ files, assignFiles, onFileDrop, isUploadingFiles }) => {
    return <>
        {!isArrayNullOrEmpty(files) && (<FormControl>
            <FormLabel>Files already uploaded</FormLabel>
            <FileAttachmentList files={files} downloadLinkResolver={downloadLinkResolver} editing={true} />
        </FormControl>)}
        <Spacer />
        <FormControl>
            <FormLabel>Files to add</FormLabel>
            <Dropzone multiple={false} onDrop={onFileDrop} style={DEFAULT_DROPZONE_STYLE.default} disabledStyle={DEFAULT_DROPZONE_STYLE.disabled} activeStyle={DEFAULT_DROPZONE_STYLE.active} acceptStyle={DEFAULT_DROPZONE_STYLE.active} rejectStyle={DEFAULT_DROPZONE_STYLE.rejected}>
                <Grid justify="center" container spacing={24}>
                    <Grid item xs={6}>
                        {(() => {
                            if (!isArrayNullOrEmpty(assignFiles)) {
                                return <>
                                    {isUploadingFiles && <LinearProgress />}
                                    <p style={DEFAULT_DROPZONE_STYLE.text}>Files to be added ({assignFiles.length})</p>
                                    <ul>{assignFiles.map(f => <li key={f.id} style={DEFAULT_DROPZONE_STYLE.listItem}>{f.fileName}</li>)}</ul>
                                </>;
                            } else {
                                return <>
                                    {isUploadingFiles && <LinearProgress />}
                                    <p style={DEFAULT_DROPZONE_STYLE.text}>Click here or drag/drop a file here to upload it</p>
                                </>;
                            }
                        })()}
                    </Grid>
                </Grid>
            </Dropzone>
        </FormControl>
    </>;
}


// WEBPACK FOOTER //
// ./src/components/forms/upload-section.tsx